import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';

import { Input } from 'components/bootstrap';

import { FormDataContext } from '../common/context/FormData';
import { AdvancedOptionsContext } from '../common/context/AdvancedOptions';
import type { HandleFieldUpdateType, FormDataContextType, AdvancedOptionsContextType } from '../common/utils/types';

interface Props {
  onChange: HandleFieldUpdateType;
}

const FormAdvancedOptions = ({ onChange }: Props) => {
  const { formData } = useContext<FormDataContextType>(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { symantecEDRThrottleEnabled, disableTLSCheck } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox
        id="symantecEDRThrottleEnabled"
        defaultChecked={symantecEDRThrottleEnabled?.value}
        onChange={onChange}
      />
      <Input
        id="disableTLSCheck"
        type="checkbox"
        value="disable-tlsCheck"
        defaultChecked={disableTLSCheck?.value}
        onChange={onChange}
        label="Disable TLS Validation"
        help="Disable the TLS validation and trust all connection?"
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
